<template>
  <ModalContainer>
    <div class="success">
      <div class="img-container">
        <svg
          width="6rem"
          height="6rem"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.9665 38.0337C18.3943 38.4614 18.9387 38.6753 19.5998 38.6753C20.2609 38.6753 20.8054 38.4614 21.2332 38.0337L27.9998 31.267L34.8248 38.092C35.2526 38.5198 35.7877 38.7235 36.4302 38.7033C37.0711 38.6847 37.6054 38.4614 38.0332 38.0337C38.4609 37.6059 38.6748 37.0614 38.6748 36.4003C38.6748 35.7392 38.4609 35.1948 38.0332 34.767L31.2665 28.0003L38.0915 21.1753C38.5193 20.7475 38.7231 20.2124 38.7028 19.57C38.6842 18.9291 38.4609 18.3948 38.0332 17.967C37.6054 17.5392 37.061 17.3253 36.3998 17.3253C35.7387 17.3253 35.1943 17.5392 34.7665 17.967L27.9998 24.7337L21.1748 17.9087C20.7471 17.4809 20.2127 17.2763 19.5718 17.295C18.9294 17.3152 18.3943 17.5392 17.9665 17.967C17.5387 18.3948 17.3248 18.9392 17.3248 19.6003C17.3248 20.2614 17.5387 20.8059 17.9665 21.2337L24.7332 28.0003L17.9082 34.8253C17.4804 35.2531 17.2766 35.7874 17.2968 36.4283C17.3155 37.0708 17.5387 37.6059 17.9665 38.0337ZM27.9998 51.3337C24.7721 51.3337 21.7387 50.7208 18.8998 49.495C16.0609 48.2708 13.5915 46.6087 11.4915 44.5087C9.3915 42.4087 7.72939 39.9392 6.50517 37.1003C5.27939 34.2614 4.6665 31.2281 4.6665 28.0003C4.6665 24.7725 5.27939 21.7392 6.50517 18.9003C7.72939 16.0614 9.3915 13.592 11.4915 11.492C13.5915 9.39199 16.0609 7.7291 18.8998 6.50333C21.7387 5.2791 24.7721 4.66699 27.9998 4.66699C31.2276 4.66699 34.2609 5.2791 37.0998 6.50333C39.9387 7.7291 42.4082 9.39199 44.5082 11.492C46.6082 13.592 48.2703 16.0614 49.4945 18.9003C50.7203 21.7392 51.3332 24.7725 51.3332 28.0003C51.3332 31.2281 50.7203 34.2614 49.4945 37.1003C48.2703 39.9392 46.6082 42.4087 44.5082 44.5087C42.4082 46.6087 39.9387 48.2708 37.0998 49.495C34.2609 50.7208 31.2276 51.3337 27.9998 51.3337ZM27.9998 46.667C33.1721 46.667 37.5766 44.8493 41.2135 41.214C44.8488 37.5771 46.6665 33.1725 46.6665 28.0003C46.6665 22.8281 44.8488 18.4235 41.2135 14.7867C37.5766 11.1513 33.1721 9.33366 27.9998 9.33366C22.8276 9.33366 18.4238 11.1513 14.7885 14.7867C11.1516 18.4235 9.33317 22.8281 9.33317 28.0003C9.33317 33.1725 11.1516 37.5771 14.7885 41.214C18.4238 44.8493 22.8276 46.667 27.9998 46.667Z"
            fill="var(--error-color)"
          />
        </svg>
      </div>
      <h2 v-if="typeof errMsg == 'object'" class="title primary-title">
        {{ errMsg.detail }}
      </h2>
      <h2 v-else class="title primary-title">
        {{ $t(`modalError.${errMsg}`) }}
      </h2>
      <div class="btn">
        <PrimaryButton @click="buttonSuccess" :title="$t('buttons.thanks')" />
      </div>
    </div>
  </ModalContainer>
</template>

<script>
import ModalContainer from "../ModalContainer.vue";
import { useLanguage } from "@/utils/language";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import PrimaryButton from "../PrimaryButton.vue";

export default {
  components: { ModalContainer, PrimaryButton },
  props: {
    errMsg: { type: [String, Object], default: "" },
    // retryable errors (e.g. vacant_places_exceeded) close the modal so the
    // user can pick another region instead of being routed Home
    retryable: { type: Boolean, default: false },
  },
  emits: ["close"],
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter();
    const { i18nRoute } = useLanguage();
    const buttonSuccess = () => {
      if (props.retryable) {
        emit("close");
        return;
      }
      if (typeof props.errMsg == "object") {
        store.dispatch("auth/logout");
      }
      router.push(
        i18nRoute({
          name: "Home",
        })
      );
    };
    return {
      buttonSuccess,
    };
  },
};
</script>

<style lang="scss" scoped>
.success {
  background: var(--white);
  padding: 2em;
  max-width: 40rem;
  margin: 0 auto;
  border-radius: 1.13rem;
  .img-container {
    width: 100%;
    text-align: center;
    margin-bottom: 1.69rem;
    .img {
      background: transparent;
      width: 7.5rem;
      margin: 0 auto;
    }
  }
  .btn {
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 1.25rem;
  }
  .title {
    font-weight: 700;
    line-height: 2;
    text-align: center;
    margin: 0 auto;
  }
  .subtitle {
    font-weight: 600;

    line-height: 2.4;
    text-align: center;
  }
  .next-btn {
    margin-top: 3em;
    margin-left: auto;
    margin-right: auto;
  }
}
@media screen and (max-width: 1200px) {
  .success {
    background: #fff;
    padding: 2em;
    max-width: 100%;
  }
}
</style>
